<template>
    <el-tabs type="border-card" style='min-height:380px'>
    <el-tab-pane>
        <span slot="label"><i class="el-icon-folder-opened"></i> Outbox <small>(Files from Client)</small></span>
        <div class='row'>
            <div class='col-4'>
                <el-upload
                class="upload-demo mg-b-10"
                drag
                multiple
                ref="upload"
                action="http://127.0.0.1:8000/api/outbox/"
                :on-remove="handleRemove"
                :file-list="fileList"
                :on-change="handleChange"
                :auto-upload="false">
                <!-- <el-button slot="trigger" size="small" type="primary">选取文件</el-button> -->
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                <!-- <div class="el-upload__tip" slot="tip">doc, pdf, xls, txt, png files with a size less than 10MB</div> -->
                </el-upload>
                <div v-show="showProgress">
                    <el-progress style="font-size:12px" :percentage="progress"></el-progress>
                    <p style="text-align: center; margin: 10px 0; font-size:12px">
                        Uploaded size：{{ bytesToSize(loaded) }}，Total size： {{bytesToSize(total)}} 
                    </p>
                    <p style="text-align: center; margin: 10px 0; font-size:12px">
                        Please don't leave this page...
                    </p>
                </div>
                <el-button class='bg-primary' style='color:white;width:100%' size="small" @click="submitUpload">Submit</el-button>
            </div>
            <div class='col-8'>
                <div style='margin:10px;'>
                    <p class='tx-12 tx-gray-700'>
                        <i class='el-icon-info'></i>
                        The files sent to Triple A Super will be automatically forwarded to the Fund’s Documentation storage upon submission and the Fund Accounting team will be advised they have been sent.
                        The sent files are to go into the funds <a href=''>Inbox</a> and be filed into the fund’s relevant other folders later.
                    </p>
                    <div class='row tx-gray-700'>
                        <div class='col-8'>
                            <div class='media'>
                                <strong>History</strong>
                                <!-- <div class='media-body' style='margin-left:5px'>
                                    <el-input
                                        size='mini'
                                        placeholder="Search"
                                        prefix-icon="el-icon-search"
                                        v-model="input2">
                                    </el-input>
                                </div> -->
                            </div>
                        </div>
                        <div class='col-4 tx-18'>
                            <el-button type='text' v-on:click="grid=!grid" style="float:right;font-size:20px;padding:0px">
                                <i :class="grid?'el-icon-s-fold':'el-icon-s-grid'"></i>
                            </el-button>
                        </div>
                    </div>
                </div>       
                    
                <!-- <el-table
                ref="multipleTable"
                :data="tableData"
                height="380"
                style='font-size:13px;width:100%'
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
                min-width='3%'>
                </el-table-column>
                <el-table-column
                min-width='40%'
                label="Name">
                <template slot-scope="scope">
                    <img :src='getSrcFromFileName(scope.row.name)' 
                    alt="" style='width:20px;height:20px'>
                    {{ scope.row.name }}
                </template>
                </el-table-column>
                <el-table-column
                property="uploaded"
                label="Sent"
                min-width='30%'>
                </el-table-column>
                <el-table-column
                property="size"
                label="Size"
                min-width='12%'
                show-overflow-tooltip>
                </el-table-column>
                 <el-table-column
                label=""
                width='70'>
                <template>
                    <i class="el-icon-view"></i>
                    <i class="el-icon-download"></i>
                    <i class="el-icon-delete"></i>
                </template>
                 </el-table-column>
            </el-table> -->
            <div v-show="grid===false">
                <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                style="width: 100%;font-size:13px"
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
                width="55">
                </el-table-column>
                <el-table-column
                label="Name"
                width="450"
                sortable>
                <template slot-scope="scope">
                    <img :src='getSrcFromFileName(scope.row.name)' 
                    alt="" style='width:20px;height:20px;padding-right:5px'>
                    <span style="font-weight:600">{{ scope.row.name }}</span>
                </template>
                </el-table-column>
                <el-table-column
                property="uploaded"
                label="Created"
                width="150"
                sortable>
                </el-table-column>
                <el-table-column
                property="size"
                label="Size"
                show-overflow-tooltip
                sortable>
                </el-table-column>
                <el-table-column
                align="right">
                <template slot-scope="scope">
                    <!-- <i class="el-icon-view"></i> -->
                    <el-button type='text' style="font-size:12px" v-on:click="download({'file_name':scope.row.name,'file_id':scope.row.id})">
                        <i class="el-icon-download"></i>
                    </el-button>
                    <!-- <i class="el-icon-delete"></i> -->
                </template>
                    </el-table-column>
            </el-table>
            <div class='mg-t-10'>
                <el-button style='float:right' size='small' @click="multiDownload()">Download Selected</el-button>
                <!-- <el-button style='float:right;margin-right:5px' size='small' @click="toggleSelection()">Delete Selected</el-button> -->
            </div>
            </div>
            <table v-show="grid===true">
                <tr v-for="(row,index) in sliceList(tableData,4)" :key="index">
                <td v-for="(item,i) in row" :key="i">																										<el-card :body-style="{ padding: '0px' }" align="center" style="font-size:12px">
                        <img :src='getSrcFromFileName(item.name)' alt="" style='width:60px;height:60px'>
                        <div style="padding: 14px;">
                            <span style="font-weight:600">{{item.name}}</span>
                            <div class="bottom clearfix">
                                <el-row>
                                    <span style="font-size:10px">Created: {{item.uploaded}}</span>
                                </el-row>
                                <el-row>
                                    <!-- <i class="el-icon-view"></i> -->
                                    <el-button type="text" class="button" v-on:click="download({'file_name':item.name,'file_id':item.id})">
                                        <i class="el-icon-download"></i>
                                    </el-button>
                                    <!-- <i class="el-icon-delete"></i> -->
                                </el-row>
                            </div>
                        </div>
                    </el-card>
                </td>
                </tr>
            </table>
            
            </div>
        </div>
    </el-tab-pane>
    </el-tabs>

</template>
<script>
import qs from 'qs'
import axios from 'axios'
import pdf from "../../../assets/img/new/pdf.png";
import doc from "../../../assets/img/new/doc.png";
import xls from "../../../assets/img/new/xls.png";
import csv from "../../../assets/img/new/csv.png";
import txt from "../../../assets/img/new/txt.png";
import zip from "../../../assets/img/new/zip.png";
import other from "../../../assets/img/new/file.png";
import base from "../../../request/api/base";
export default {
    name: 'strategy',
    components: {

    },
    data(){
        return{
            env:base.backend,
            filesrc: {
                'pdf':pdf,
                'doc':doc,
                'xls':xls,
                'csv':csv,
                'txt':txt,
                'zip':zip,
                'other':other
            },
            fileListSample: [{
                name: 'document_1.pdf',
                url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                }, {
                name: 'document_2.doc',
                url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                },{
                name: 'document_3.doc',
                url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                }
            ],
            tableDataSample: [{
                uploaded: '03/09/2020 03:30 PM',
                name: 'sample_document_1.doc',
                size: '3.1MB'
                }, {
                uploaded: '09/11/2020 05:21 PM',
                name: 'sample_document_2.pdf',
                size: '20KB'
                }, {
                uploaded: '02/06/2020 09:35 AM',
                name: 'sample_document_3.xls',
                size: '2.8MB'
                }, {
                uploaded: '08/06/2021 09:20 AM',
                name: 'sample_document_4.xls',
                size: '68KB'
                }, {
                uploaded: '29/06/2021 09:26 AM',
                name: 'sample_document_5.xls',
                size: '93KB'
                }
            ],
            loaded: 0,
            total: 0,
            progress: 0,
            showProgress:false,
            fileList:[],
            tableData:[],
            loading:true,
            grid:false,
            multipleSelection: []
        }
    },
    computed: {
        sliceList() {
            return function (data,count) {
            if (data != undefined) {
                let index = 0;
                let arrTemp = [];
                for (let i = 0; i < data.length; i++) {
                index = parseInt(i / count);
                if (arrTemp.length <= index) {
                    arrTemp.push([]);
                }
                arrTemp[index].push(data[i])
                }
                return arrTemp
            }
            }
        }
    },
    created(){
        this.getFileDict()
    },
    methods:{
        getFileDict(){
            this.$api.funddashboard_api.documents(this.$route.params.fund_code,{'folder':'outbox'}).then(response =>{
                this.tableData = response.data['files_dict']
                this.loading = false
            });
        },
        download(params){
            this.$api.funddashboard_api.download(this.$route.params.fund_code,params).then(response =>{
                window.open(response.data['file_url'], '_blank');
            });
        },
        multiDownload(){
            for(let item of this.multipleSelection){
                this.download({'file_name':item.name,'file_id':item.id})
            }
        },
        getSrcFromFileName(filename){
            const suffix = filename.slice(-3)
            if(suffix==="pdf"){
                return this.filesrc.pdf;
            }else if(suffix==="doc" || suffix==="ocx"){
                return this.filesrc.doc;
            }else if(suffix==="txt"){
                return this.filesrc.txt;
            }else if(suffix==="xls"){
                return this.filesrc.xls;
            }else if(suffix==="csv"){
                return this.filesrc.csv;
            }else if(suffix==="zip"){
                return this.filesrc.zip;
            }else{
                return this.filesrc.other;
            }
                              
        },
        //文件状态改变
        handleChange (file, fileList) {
            this.fileList = fileList;
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        submitUpload() {
            let formData = new FormData();  
            for(let i = 0;i<this.fileList.length;i++){
                formData.append('file'+i, this.fileList[i].raw)
            }
            this.showProgress = true
            axios({
                headers:{'Content-Type':'multipart/form-data'},
                url: this.env+'/api/outbox/', 
                data:formData,
                onUploadProgress: pe => {
                    this.progress = Number.parseInt((pe.loaded / pe.total) * 100)
                    this.loaded = pe.loaded
                    this.total = pe.total
                },
                params:{'fund_code':this.$route.params.fund_code},
                method: 'POST',
            }).then(res => {
                console.log('-------res--------')
                console.log(res)
                if (res.data.status === '200') {
                    this.$message.success(res.data.msg)
                    this.fileList = []
                    this.progress = this.loaded = this.total = 0
                    this.showProgress = false
                    this.getFileDict()
                } else {
                    this.$message.error(res.data.msg)
                }
                }, err => {
                console.log('-------err--------')
                console.log(err)
                this.$message.error('Error!')
            })
        },
        toggleSelection(rows) {
            if (rows) {
            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
            } else {
            this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        }
    }
}
</script>
<style>
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: black;
    background-color: #FFF;
    border-right-color: #DCDFE6;
    border-left-color: #DCDFE6;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: black;
}
.el-upload-dragger .el-upload__text em {
    color: #3366ff;
    font-style: normal;
}
.el-upload {
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: 0;
    width:100%;
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #3366ff;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>